import { __assign, __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { Tooltip as ReactTooltip, } from "react-tooltip";
import { useTheme } from "styled-components";
export var Tooltip = forwardRef(function Tooltip(_a, ref) {
    var dark = _a.dark, children = _a.children, props = __rest(_a, ["dark", "children"]);
    var theme = useTheme();
    return (_jsx(ReactTooltip, __assign({ opacity: 1, ref: ref }, props, { style: __assign({ backgroundColor: dark
                ? theme.colors.neutral.darker
                : theme.colors.neutral.white, padding: "".concat(theme.spacing.xs, " ").concat(theme.spacing.s), borderRadius: theme.radius.s, color: dark ? theme.colors.neutral.lightest : theme.colors.neutral.dark, fontSize: 12, fontWeight: 500, zIndex: 999, filter: "drop-shadow(0px 0px 2px #0000001F) drop-shadow(0px 2px 4px #00000024)" }, props.style), children: children })));
});
//# sourceMappingURL=index.js.map